import { setSession, updateShopId } from 'src/reducer/order/orderReducer';
import * as reducer from 'src/reducer/order/orderReducer';
import {
  getMenuThunk,
  getCurrentOrderThunk,
} from 'src/reducer/order/orderThunk';
import { useParams } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from 'src/app/store';
import { gentoken } from 'src/utils';
import { useEffect } from 'react';

export function useInitSession() {
  const dispatch = useAppDispatch();
  const appState = useAppSelector(state => state.order);
  const pathParams = useParams();

  let shopId = pathParams.shopId;
  let code = pathParams.code;

  useEffect(() => {
    if (shopId != null) {
      if (shopId != appState.shopId) {
        dispatch(reducer.reset(0));
        dispatch(reducer.updateShopId(shopId));
      } else if (appState.menuDef == null) {
      }
    }
    if (code != null) {
      if (appState.session.code != code) {
        dispatch(
          setSession({
            kind: 'Table',
            code: pathParams.code!,
            childId: gentoken().substring(0, 6),
          }),
        );
      }
    }
    // need to have condition to prevent loop on these requests
    if (appState.loadOrderStatus == null) {
      dispatch(getCurrentOrderThunk({ shopId: shopId!, withMenu: true }));
    } else if (appState.menuDef == null) {
      dispatch(getMenuThunk(null));
    }
  }, [dispatch, appState, pathParams]);
}
